import { render, staticRenderFns } from "./AutoWaitingCall.vue?vue&type=template&id=0897c944&scoped=true&"
import script from "./AutoWaitingCall.vue?vue&type=script&lang=js&"
export * from "./AutoWaitingCall.vue?vue&type=script&lang=js&"
import style0 from "./AutoWaitingCall.vue?vue&type=style&index=0&id=0897c944&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0897c944",
  null
  
)

export default component.exports